/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignInboundFaxDto
 */
export interface AssignInboundFaxDto {
    /**
     * Patient ID to assign this inbound fax to
     * @type {string}
     * @memberof AssignInboundFaxDto
     */
    patientId: string;
}

/**
 * Check if a given object implements the AssignInboundFaxDto interface.
 */
export function instanceOfAssignInboundFaxDto(value: object): value is AssignInboundFaxDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    return true;
}

export function AssignInboundFaxDtoFromJSON(json: any): AssignInboundFaxDto {
    return AssignInboundFaxDtoFromJSONTyped(json, false);
}

export function AssignInboundFaxDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignInboundFaxDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
    };
}

export function AssignInboundFaxDtoToJSON(json: any): AssignInboundFaxDto {
    return AssignInboundFaxDtoToJSONTyped(json, false);
}

export function AssignInboundFaxDtoToJSONTyped(value?: AssignInboundFaxDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
    };
}

